import { CustomFormattedMessage } from '../../../../../../i18n/i18n';
import map from 'lodash/map';
import { ServiceExpander } from './ServiceExpander';
import { useServiceConfigurationFormContext } from '../ServiceConfigurationForm';
import { UserManualLink } from '../../../../../../components/dialog/userManualDialog/UserManualLink';
import { userManualDialogChapters } from '../../../../../../state/dialogs/chapters';

export const ServiceTabContent = () => {
  const fomContext = useServiceConfigurationFormContext();
  const formData = fomContext.watch();

  return (
    <>
      <div className="text-size-16 text-medium margin-top-20 margin-bottom-20">
        <CustomFormattedMessage id={'onboarding.dialog.services.message'} />
        <UserManualLink
          chapter={userManualDialogChapters.activatingServices}
          dataTestId="user-manual-link-configure-services"
        />
      </div>
      {map(formData.serviceActivations, (s) => (
        <ServiceExpander
          serviceType={s.serviceType}
          key={s.serviceType}
        />
      ))}
    </>
  );
};
